import { useQuery } from "@apollo/client";
import {
  GET_SHARED_CLIENT_ACCOUNT,
  GET_SHARED_FAVORITE_BUSINESSES,
} from "../queries/favorites";

export const useSharedClientAccount = (token: string | undefined) => {
  return useQuery(GET_SHARED_CLIENT_ACCOUNT, {
    variables: { token },
    skip: !token,
  });
};

export const useSharedFavoriteBusinesses = (
  token: string | undefined,
  options?: { first?: number; after?: string }
) => {
  return useQuery(GET_SHARED_FAVORITE_BUSINESSES, {
    variables: {
      token,
      first: options?.first ?? 24,
      after: options?.after,
    },
    skip: !token,
  });
};
